<template>
  <ExtraNationalityFields v-model="nationality">
    <AppRow sequence-two>
      <NationalitySelect v-model="nationality.country" hide-hint />
      <TextField v-model="nationality.number" :label="$tt('extra_nationality.passport_or_id')" />
      <DateOfIssue v-model="nationality.from" :hint="$tt('estimate_date')" past />
    </AppRow>
  </ExtraNationalityFields>
</template>

<script setup lang="ts">
import type { ExtraNationality } from '~/types';
const nationality = defineModel<ExtraNationality>({ required: true });
</script>